import React, { Dispatch, SetStateAction } from 'react';
import { ContactInput, Person } from 'sr-types/lib/person/v1/graphql';
import PersonQuickAdd from '../../../common/components/person/quickAddPerson/PersonQuickAdd';
import FormModal from '../../../common/form/FormModal';
import I18n from '../../../common/i18n/I18n';
import { H } from '../../../common/Layout';
import { usePersonProvider } from '../../PersonContext';

type QuickAddPersonModalProps = {
    personData: Map<string, string>;
    setShowPersonEditor: Dispatch<SetStateAction<boolean>>;
    setInitialState: Dispatch<SetStateAction<ContactInput>>;
    allowMissingEmail?: boolean;
};

function QuickAddPersonModal({
    personData,
    setShowPersonEditor,
    setInitialState,
    allowMissingEmail = false
}: QuickAddPersonModalProps) {
    const { setIsBusinessContactEditorOpen } = usePersonProvider();

    const addPersonAsBusinessContact = (person: Person) => {
        const contactInput: ContactInput = {
            name: person.name,
            contactInfo: person.contactInfo,
            personReference: person.reference
        } as ContactInput;

        setShowPersonEditor(false);
        setIsBusinessContactEditorOpen(true);
        setInitialState(contactInput);
    };

    return (
        <FormModal
            id={'quick-add-person-modal'}
            title={<I18n token="form.person.create" />}
            isOpen
            onClose={() => setShowPersonEditor(false)}
            hideDefaultButtons
            slots={{
                backdrop: ({ onClick }) => <H fill onClick={onClick} children={undefined} />
            }}
        >
            <PersonQuickAdd
                newContactData={personData}
                onCancel={() => setShowPersonEditor(false)}
                onAdd={addPersonAsBusinessContact}
                showOnlyBasicInfoFields
                showOnlyOrganizationField
                containerSx={{ height: '100%' }}
                allowMissingEmail={allowMissingEmail}
            />
        </FormModal>
    );
}

export default QuickAddPersonModal;
